/* eslint-disable */
"use strict";

// import Semaphore from 'semaphore-async-await'

import configurazioni from "@/services/configurazioniService.js";
import store from "@/store";
// import prodotti from '../store/${products}'

var config, service, products;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  products = config.VUE_APP_MOL_S_PRODUCTS
}

const NodeCache = require("node-cache");
const prodottiCache = new NodeCache(); // TODO: Uniformare le cache node-cache ed altre, ne basta un solo tipo ...
const prodottiPreCache = new NodeCache();
// const lock = new Semaphore(1);

let bearerToken = "";
let popolaPreCacheInCorso = false;

const LRU = require("lru-cache");
const options = { max: 500, maxAge: 1000 * 60 * 60 }; // TODO: prevedere comando di svuotamento
const cache = new LRU(options);

function setToken(key) {
  bearerToken = key;
}

function getToken() {
  return JSON.parse(localStorage.getItem("token_bk")) || "";
}

async function getAllProducts() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${products}`);
  return await response.json();
}

/* async function cicleSync() {
  try {
    prodottiCache.flushAll()
    prodottiPreCache.flushAll()
    const response = await fetch(`${service}/${products}/cicleSync`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
    setTimeout(async () => await popolaPreCache(), 500)
    return await response.json()
  } catch (error) {
    return null
  }
} */

async function cicleSync(multiplo) {
  if (!config || !service) {
    await getConfigFile();
  }
  prodottiCache.flushAll();
  prodottiPreCache.flushAll();
  // prodottiPreCache.flushAll()
  try {
    const response = await fetch(`${service}/${products}/cicleSync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ multiplo }),
    });
    setTimeout(async () => await popolaPreCache(), 500);
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function getRunMode() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${products}/mode`);
    return await response.json();
  } catch {
    return {
      modulo: "PRODOTTI",
      locale: "---",
      remote: "---",
      versione: "---",
      health: "---",
    };
  }
}

async function popolaPreCache(flush) {
  if (popolaPreCacheInCorso) return;
  popolaPreCacheInCorso = true;
  console.log("popolaPreCache");
  if (flush) {
    prodottiPreCache.flushAll();
  }
  if (prodottiPreCache.getStats().keys === 0) {
    const elenco = await getAllProducts();
    if (elenco.rows && elenco.rows.length > 0) {
      prodottiPreCache.mset(
        elenco.rows.map((r) => {
          return {
            key: String(r.id),
            val: r.doc,
          };
        })
      );
    }
  }
  popolaPreCacheInCorso = false;
}

async function clearCache() {
  prodottiCache.flushAll();
  prodottiPreCache.flushAll();
  await popolaPreCache();
}

async function getFilteredProducts(filtri, opzioni, versione, force) {
  if (!config || !service) {
    await getConfigFile();
  }
  const id = filtri.id;
  if (id) {
    // cerca nella cache dei prodotti solo per codice, se trova ok, altrimenti prosegue
    if (prodottiPreCache.getStats().keys === 0) {
      await popolaPreCache();
    }
    if (force) {
      prodottiPreCache.del(id);
    }
    const vca = prodottiPreCache.get(id);
    if (vca !== undefined) {
      return {
        total_rows: 1,
        rows: [{ doc: vca }],
      };
    }
  }
  const key = JSON.stringify({ filtri, opzioni });
  const value = prodottiCache.get(key);
  if (value !== undefined && !force) {
    return value;
  }

  const data = {
    filtri,
    opzioni,
  };
  try {
    const response = await fetch(
      `${service}/${products}/${versione ? versione + "/" : ""}filter`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    // return await response.json()
    const result = await response.json();
    if (!(filtri.testo && filtri.testo.startsWith("%"))) {
      prodottiCache.set(key, result);
    }
    return result;
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function getProdottiByIds(ids) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${products}/ids`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ids),
    });
    const result = await response.json();
    return result.rows
      .filter((x) => !x.error && !x.value.deleted)
      .map((x) => x.doc);
  } catch (error) {
    // winston.error(`getProdottiByIds: ${error}`);
    console.log(error);
    return [];
  }
}

async function getModello(tipo) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${products}/modello${tipo ? "?tipo=" + tipo : ""}`
  );
  return await response.json();
}

async function getProdotto(codice) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${products}/${codice}`);
  return await response.json();
}

async function searchProdotti(searchText) {
  if (!config || !service) {
    await getConfigFile();
  }
  const key = searchText;
  const value = prodottiCache.get(key);
  if (value !== undefined) {
    console.log("trovato cache", key);
    return value;
  }

  // prevedere token
  const response = await fetch(
    `${service}/${products}/search?flt=${searchText}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getToken(),
      },
    }
  );

  // const response = await fetch(`${service}/${products}/search?flt=${searchText}`)
  const result = await response.json();
  prodottiCache.set(key, result);
  return result;
  // return await response.json()
}

async function searchProdottiPost(searchText, onlyIndices, limit, filtri) {
  if (!config || !service) {
    await getConfigFile();
  }
  // prevedere token
  const data = {
    searchText,
    onlyIndices,
    limit,
    filtri,
  };

  const key = JSON.stringify(data);
  const value = prodottiCache.get(key);
  if (value !== undefined) {
    console.log("trovato cache", key);
    return value;
  }

  const response = await fetch(`${service}/${products}/search`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getToken(),
    },
    body: JSON.stringify(data),
  });
  const result = await response.json();
  prodottiCache.set(key, result);
  return result;
}

async function searchProdottiTC(searchText) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${products}/search/tc?flt=${searchText}`
  );
  return await response.json();
}

// Ritorna il documento completo del prodotto
async function getDettaglioProdotto(code) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${products}/${code}`);
  return await response.json();
}

async function creaProdotto(prodotto) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${products}/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(prodotto),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function aggiornaProdotto(prodotto) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const id = encodeURIComponent(prodotto._id);
    const response = await fetch(`${service}/${products}/${id}/update`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(prodotto),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function aggiornaPrezzo(tipoPrezzo, idProdotto, chiave, valore) {
  if (!config || !service) {
    await getConfigFile();
  }
  // tipo = listino / cliente/ tipoCliente/ acquisto
  // chiave = (se listino) --> codiceListino, (se cliente) --> codiceCliente, (se TipoCliente) --> tipoCliente
  try {
    const id = encodeURIComponent(idProdotto);
    const data = {
      tipoPrezzo,
      chiave,
      valore,
    };
    const response = await fetch(`${service}/${products}/${id}/update/prezzo`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function aggiornaDeltaGiacenza(prodottoId, magazzino, deltaGiacenza) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      id: prodottoId,
      magazzino,
      deltaGiacenza,
    };
    const response = await fetch(`${service}/${products}/${prodottoId}/delta`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function cancellaProdotto(prodotto) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${products}/${prodotto._id}/delete`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
    return await response.json();
  } catch (error) {
    return null;
  }
}

// Ritorna solo alcuni campi del documento utili per la visualizzazione
async function getInfoProdotto(
  code,
  listino,
  variante,
  cliente,
  aliquota,
  barcode
) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    code,
    listino,
    variante: variante || "",
    cliente: cliente || "",
    aliquota,
    barcode, // opzionale, se presente in alternativa al codice prodotto
  };
  const searchText = JSON.stringify(data);
  const cachedValue = cache.get(searchText);
  if (cachedValue) {
    return cachedValue;
  }
  const url = `${service}/${products}/info/scontrino`;

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ data }),
  });
  const result = await response.json();
  cache.set(searchText, result);

  return result;
}

async function getServizi(searchText) {
  if (!config || !service) {
    await getConfigFile();
  }
  let url = `${service}/${products}/servizi`;
  if (searchText) {
    url += `?flt=${searchText}`;
  }
  const response = await fetch(url);
  return await response.json();
}

async function getMenuComposti(searchText) {
  if (!config || !service) {
    await getConfigFile();
  }
  let url = `${service}/${products}/menucomposti`;
  if (searchText) {
    url += `?flt=${searchText}`;
  }
  const response = await fetch(url);
  return await response.json();
}

async function getInfoFromBarcode(barcode) {
  if (!config || !service) {
    await getConfigFile();
  }
  console.log("prodotti--> getInfoFromBarcode");
  // const response = await fetch(`${service}/${products}/barcode/${barcode}`)
  const response = await fetch(
    `${service}/${products}/barcode/index/${barcode}`
  );
  return await response.json();
}

async function getListBarcode(barcode) {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${products}/barcode/list/${barcode}`
  );
  return await response.json();
}

async function getProdottiEcommerce(isECommerce, idSku) {
  if (!config || !service) {
    await getConfigFile();
  }
  let url = `${service}/${products}/ecommerce?ec=${
    isECommerce ? "true" : "false"
  }`;
  if (idSku) {
    url += `&sku=${idSku}`;
  }
  const response = await fetch(url);
  const elenco = await response.json();
  return elenco.docs || [];
}

async function creaProdottoTestBarcode(barcode, prodotto, nomeImport) {
  if (!config || !service) {
    await getConfigFile();
  }
  delete prodotto.barcode;
  var data = {
    barcode,
    codice: prodotto.codice,
    nomeImport,
    prodotto,
  };
  const response = await fetch(`${service}/${products}/create/barcode`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function creaProdottiMultipliTestBarcode(
  prodotti,
  nomeImport,
  usaTagliaColore,
  skipEsistente
) {
  if (!config || !service) {
    await getConfigFile();
  }
  var data = {
    prodotti,
    nomeImport,
    usaTagliaColore,
    skipEsistente,
  };
  const response = await fetch(
    `${service}/${products}/multipli/create/barcode`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }
  );
  return await response.json();
}

async function creaBarcodeProdotto() {
  if (!config || !service) {
    await getConfigFile();
  }
  var barcode = await configurazioni.getBarcodeInfo("prodotto");
  const data = {
    prefisso: `${barcode.prefissoInterno}`, // TODO: verificare, prefissoInterno viene utilizzato per generare manualemnte i codici
    ultimoNumero: barcode.ultimoNumero,
    tipo: barcode.tipoCodice,
  };
  const response = await fetch(`${service}/${products}/barcode/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  const barcodeCreato = await response.json();
  await configurazioni.setBarcodeInfo(
    "prodotto",
    "write",
    barcodeCreato.ultimoNumero
  );
  return barcodeCreato;
}

async function generaBarcodeProdotto() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(`${service}/${products}/barcode/generate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  const result = await response.json();
  return result.barcode;
}

async function generaBarcodeProdottoPV() {
  if (!config || !service) {
    await getConfigFile();
  }
  const response = await fetch(
    `${service}/${products}/barcode/generate/variabile`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    }
  );
  const result = await response.json();
  return result.barcode;
}

async function estraeCategorie(nomeCampoSorgente) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      nomeCampoSorgente,
    };
    const response = await fetch(`${service}/${products}/categorie`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(`estraeCategorie: ${error}`);
    return error;
  }
}

async function aggiornaGiacenzaMultipla(parametri, prodotti, usaTagliaColore) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    // leggere il magazzino selezionato (per il calcolo della giacenza).
    const magazzino = store.getters["magazzini/codiceMagazzino"];
    console.log(magazzino);
    parametri.magazzino = parametri.magazzino || magazzino;
    const data = {
      parametri,
      prodotti,
      usaTagliaColore,
    };
    const response = await fetch(`${service}/${products}/multipli/giacenza`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    console.log(`aggiornaGiacenzaMultipla: ${error}`);
  }
  return false;
}

async function verificaBarcodeValido(barcode) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${products}/barcode/test/${barcode}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
    return await response.json();
  } catch (err) {
    return true;
  }
}

async function addBarcodeProdotto(prodottoId, barcode) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      code: barcode,
      id: prodottoId,
      tc: usaTagliaColore,
    };
    const response = await fetch(`${service}/${products}/barcode/add`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    return true;
  } catch (err) {
    return false;
  }
}

async function abilitaECommerceByIds(ids, abilita) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      ids,
      abilita,
    };
    const response = await fetch(`${service}/${products}/ecommerce/ids`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    prodottiCache.flushAll();
    return result;
  } catch (error) {
    // winston.error(`getProdottiByIds: ${error}`);
    console.log(error);
    return [];
  }
}

async function ecommerceSincronizzaVariazioni() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${products}/ecommerce/variazioni`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      }
    );
    const result = await response.json();
    prodottiCache.flushAll();
    return result;
  } catch (error) {
    // winston.error(`getProdottiByIds: ${error}`);
    console.log(error);
    return [];
  }
}

async function prodottiPerTipoBene(
  tipoBene,
  onlyIndices,
  limit,
  tipoItem,
  fields
) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      tipoBene,
      onlyIndices,
      limit,
      tipoItem,
      fields,
    };
    const response = await fetch(`${service}/${products}/tipo/bene`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function prodottiPerTipoItem(tipoItem, onlyIndices, limit) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      tipoItem,
      onlyIndices,
      limit,
    };
    const response = await fetch(`${service}/${products}/tipo/item`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

function creaCampoRicercaTC_Codici(codice, taglia, colore) {
  var pattern = /[^a-zA-Z0-9-]+/gi;
  var campo = String(codice) + String(taglia) + String(colore);
  return campo.replace(pattern, "_").toLowerCase();
}

// TODO: Su moleculer va fatto un servizio unico per tutti gli allegati (clienti, prodotti, documenti, etc) che poi utilizza Amazon S3 come repository (NON su server IBM)

async function aggiornaAllegati(idProdotto, allegati) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    prodottiPreCache.del(idProdotto);
    const response = await fetch(
      `${service}/${products}/${idProdotto}/allegati`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(allegati),
      }
    );

    return await response.json();
  } catch (error) {
    return null;
  }
}

async function eliminaAllegato(idProdotto, allegato) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${products}/${idProdotto}/allegati/delete`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(allegato),
      }
    );
    prodottiPreCache.del(idProdotto);
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function elencoProdottiGestione(filtri) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filtri,
    };
    const response = await fetch(`${service}/${products}/gestione`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

export default {
  cicleSync,
  getRunMode,
  clearCache,
  popolaPreCache,
  setToken,
  getAllProducts,
  getFilteredProducts,
  getProdottiByIds,
  getModello,
  getProdotto,
  searchProdotti,
  searchProdottiPost,
  searchProdottiTC,
  getServizi,
  getMenuComposti,
  getProdottiEcommerce,
  creaProdotto,
  aggiornaProdotto,
  aggiornaPrezzo,
  aggiornaDeltaGiacenza,
  creaProdottoTestBarcode,
  getInfoProdotto,
  getDettaglioProdotto,
  getInfoFromBarcode,
  getListBarcode,
  creaBarcodeProdotto,
  generaBarcodeProdotto,
  generaBarcodeProdottoPV,
  creaProdottiMultipliTestBarcode,
  estraeCategorie,
  cancellaProdotto,
  aggiornaGiacenzaMultipla,
  verificaBarcodeValido,
  addBarcodeProdotto,
  abilitaECommerceByIds,
  prodottiPerTipoBene,
  prodottiPerTipoItem,
  creaCampoRicercaTC_Codici,
  aggiornaAllegati,
  eliminaAllegato,
  ecommerceSincronizzaVariazioni,
  elencoProdottiGestione,
};
